import './App.scss';
import Routes from "./Router";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GOOGLE_OAUTH } from './config/config';
import { setAuth } from './stores/authStore';
import { jwtDecode } from 'jwt-decode';

if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.info = () => {};
  console.warn = () => {};
  console.error = () => {};
}

// Hydrate auth store synchronously from sessionStorage — no network call, no blocking
const storedToken = sessionStorage.getItem('accessToken');
if (storedToken) {
  try {
    const decoded = jwtDecode(storedToken);
    const user = decoded.admin || decoded.owner || decoded.user || {};
    const role = decoded.admin ? 'admin' : decoded.owner ? 'partner' : null;
    setAuth(user, storedToken, role);
  } catch {
    sessionStorage.removeItem('accessToken');
  }
}

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_OAUTH.CLIENT_ID}>
      <Routes />
    </GoogleOAuthProvider>
  );
}

export default App;
